import type React from 'react';
import { NamesStep } from '@/pages/catalogImport/names';
import { ProductsStep } from '@/pages/catalogImport/products';
import { ResultStep } from '@/pages/catalogImport/result';
import { UploadStep } from '@/pages/catalogImport/upload';
import { ImportHistory } from '../importHistory';
import type {
    BranchImportStep,
    BranchImportStepPaths,
} from '../../useBranchImportPage';

type ImportStepBodyProps = {
    /** The page's branch, for the history under Upload. */
    branchId: string;
    step: BranchImportStep;
    paths: BranchImportStepPaths;
};

/**
 * The current step of the in-shell import: the wizard's own Upload, Names,
 * Products and Result in `shell` mode, with the page's paths, and the
 * branch's import history under Upload. Result offers no Undo: the page runs
 * after onboarding, when the server refuses every undo.
 */
export const ImportStepBody: React.FC<ImportStepBodyProps> = ({
    branchId,
    step,
    paths,
}) => {
    switch (step) {
        case 'file':
            return (
                <div className="flex flex-col gap-4 pb-4 sm:pb-8">
                    <UploadStep
                        backPath={paths.file.backPath}
                        mode="shell"
                        nextPath={paths.file.nextPath}
                    />
                    <ImportHistory branchId={branchId} />
                </div>
            );
        case 'names':
            return (
                <NamesStep
                    backPath={paths.names.backPath}
                    nextPath={paths.names.nextPath}
                />
            );
        case 'products':
            return (
                <ProductsStep
                    backPath={paths.products.backPath}
                    nextPath={paths.products.nextPath}
                />
            );
        case 'result':
            return (
                <ResultStep
                    anotherFilePath={paths.result.anotherFilePath}
                    backPath={paths.result.backPath}
                    mode="shell"
                    nextPath={paths.result.nextPath}
                    showUndo={false}
                />
            );
    }
};
